import { createFileRoute } from '@tanstack/react-router';

import { AdminEditUserModal } from '~/components/modals/user/AdminEditUserModal';
import { USER_ROLES } from '~/features/auth/roles';
import { useGoBack } from '~/hooks/useGoBack';
import { Route as AbbottAdminUsersRoute } from '~/routes/abbott-administration/users';
import { protectedRoute } from '~/utils/routesAuthorization';

const TEST_ID = 'abbott-user-details';

export const Route = createFileRoute(
  '/abbott-administration/users/profile/$userId',
)({
  component: EditUserRoute,
  params: {
    parse: (params) => ({ userId: params.userId }),
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.AbbottUser, USER_ROLES.AdminAbbott],
    });
  },
});

function EditUserRoute() {
  const { userId } = Route.useParams();

  const goBack = useGoBack({ fallbackPath: AbbottAdminUsersRoute.fullPath });

  return (
    <AdminEditUserModal
      userId={userId}
      testID={TEST_ID}
      hiddenFields={['departmentId', 'idnId']}
      onCloseRedirectPath={AbbottAdminUsersRoute.fullPath}
      onActionComplete={goBack}
    />
  );
}
